import React from "react";

import TermsAndConditionsSlice from "../../components/slices/terms/TermsAndConditionsSlice";

const TermsAndConditions = ({ slice }) => {
  return <TermsAndConditionsSlice slice={slice} />;
};

export default TermsAndConditions;
